"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Wed Jun 27 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var ConstraintConverterResolver_1 = require("./conversions/constraint/ConstraintConverterResolver");

var ConstraintConverterResolverImpl_1 = require("./conversions/constraint/ConstraintConverterResolverImpl");

var ConstraintSettingsConverter_1 = require("./conversions/constraint/ConstraintSettingsConverter");

var ConstraintSettingsConverterImpl_1 = require("./conversions/constraint/ConstraintSettingsConverterImpl");

var RangeConstraintConverter_1 = require("./conversions/constraint/RangeConstraintConverter");

var RangeConstraintConverterImpl_1 = require("./conversions/constraint/RangeConstraintConverterImpl");

var RangeConverter_1 = require("./conversions/constraint/RangeConverter");

var RangeConverterImpl_1 = require("./conversions/constraint/RangeConverterImpl");

var SimpleConstraintConverter_1 = require("./conversions/constraint/SimpleConstraintConverter");

var SimpleConstraintConverterImpl_1 = require("./conversions/constraint/SimpleConstraintConverterImpl");

var WeekDayRestrictionConverter_1 = require("./conversions/constraint/WeekDayRestrictionConverter");

var WeekDayRestrictionConverterImpl_1 = require("./conversions/constraint/WeekDayRestrictionConverterImpl");

var SettingsChildrenStatsConverter_1 = require("./conversions/dto/SettingsChildrenStatsConverter");

var SettingsChildrenStatsConverterImpl_1 = require("./conversions/dto/SettingsChildrenStatsConverterImpl");

var SettingsOverviewDTOConverter_1 = require("./conversions/dto/SettingsOverviewDTOConverter");

var SettingsOverviewDTOConverterImpl_1 = require("./conversions/dto/SettingsOverviewDTOConverterImpl");

var SettingsZonesOverviewDTOConverter_1 = require("./conversions/dto/SettingsZonesOverviewDTOConverter");

var SettingsZonesOverviewDTOConverterImpl_1 = require("./conversions/dto/SettingsZonesOverviewDTOConverterImpl");

var OptimizationGoalsSettingsConverter_1 = require("./conversions/optimalization-goal/OptimizationGoalsSettingsConverter");

var OptimizationGoalsSettingsConverterImpl_1 = require("./conversions/optimalization-goal/OptimizationGoalsSettingsConverterImpl");

var RoundingRuleConverter_1 = require("./conversions/rounding-rule/RoundingRuleConverter");

var RoundingRuleConverterImpl_1 = require("./conversions/rounding-rule/RoundingRuleConverterImpl");

var SettingsConverter_1 = require("./conversions/SettingsConverter");

var SettingsConverterImpl_1 = require("./conversions/SettingsConverterImpl");

var MultiTargetStrategyConverter_1 = require("./conversions/strategy/MultiTargetStrategyConverter");

var MultiTargetStrategyConverterImpl_1 = require("./conversions/strategy/MultiTargetStrategyConverterImpl");

var SingleTargetStrategyConverter_1 = require("./conversions/strategy/SingleTargetStrategyConverter");

var SingleTargetStrategyConverterImpl_1 = require("./conversions/strategy/SingleTargetStrategyConverterImpl");

var StrategyConverterResolver_1 = require("./conversions/strategy/StrategyConverterResolver");

var StrategyConverterResolverImpl_1 = require("./conversions/strategy/StrategyConverterResolverImpl");

var StrategySettingsConverter_1 = require("./conversions/strategy/StrategySettingsConverter");

var StrategySettingsConverterImpl_1 = require("./conversions/strategy/StrategySettingsConverterImpl");
/**
 * Configures settings app module.
 */


var GeneralSettingsAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(GeneralSettingsAppModule, _AppModule_1$AppModul);

  function GeneralSettingsAppModule() {
    var _this;

    _classCallCheck(this, GeneralSettingsAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GeneralSettingsAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'generalSettingsAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(GeneralSettingsAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(SettingsConverter_1.SettingsConverter).to(SettingsConverterImpl_1.SettingsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      this.configureRoundingRules();
      this.configureStrategiesParts();
      this.configureOptimizationGoalsParts();
      this.configureConstraintsParts();
      this.configureDTOsParts();
    }
  }, {
    key: "configureRoundingRules",
    value: function configureRoundingRules() {
      typescript_ioc_1.Container.bind(RoundingRuleConverter_1.RoundingRuleConverter).to(RoundingRuleConverterImpl_1.RoundingRuleConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }, {
    key: "configureOptimizationGoalsParts",
    value: function configureOptimizationGoalsParts() {
      typescript_ioc_1.Container.bind(OptimizationGoalsSettingsConverter_1.OptimizationGoalsSettingsConverter).to(OptimizationGoalsSettingsConverterImpl_1.OptimizationGoalsSettingsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }, {
    key: "configureConstraintsParts",
    value: function configureConstraintsParts() {
      typescript_ioc_1.Container.bind(ConstraintSettingsConverter_1.ConstraintSettingsConverter).to(ConstraintSettingsConverterImpl_1.ConstraintSettingsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(RangeConstraintConverter_1.RangeConstraintConverter).to(RangeConstraintConverterImpl_1.RangeConstraintConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WeekDayRestrictionConverter_1.WeekDayRestrictionConverter).to(WeekDayRestrictionConverterImpl_1.WeekDayRestrictionConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SimpleConstraintConverter_1.SimpleConstraintConverter).to(SimpleConstraintConverterImpl_1.SimpleConstraintConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ConstraintConverterResolver_1.ConstraintConverterResolver).to(ConstraintConverterResolverImpl_1.ConstraintConverterResolverImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(RangeConverter_1.RangeConverter).to(RangeConverterImpl_1.RangeConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }, {
    key: "configureStrategiesParts",
    value: function configureStrategiesParts() {
      typescript_ioc_1.Container.bind(MultiTargetStrategyConverter_1.MultiTargetStrategyConverter).to(MultiTargetStrategyConverterImpl_1.MultiTargetStrategyConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SingleTargetStrategyConverter_1.SingleTargetStrategyConverter).to(SingleTargetStrategyConverterImpl_1.SingleTargetStrategyConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(StrategySettingsConverter_1.StrategySettingsConverter).to(StrategySettingsConverterImpl_1.StrategySettingsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(StrategyConverterResolver_1.StrategyConverterResolver).to(StrategyConverterResolverImpl_1.StrategyConverterResolverImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }, {
    key: "configureDTOsParts",
    value: function configureDTOsParts() {
      typescript_ioc_1.Container.bind(SettingsChildrenStatsConverter_1.SettingsChildrenStatsConverter).to(SettingsChildrenStatsConverterImpl_1.SettingsChildrenStatsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SettingsOverviewDTOConverter_1.SettingsOverviewDTOConverter).to(SettingsOverviewDTOConverterImpl_1.SettingsOverviewDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SettingsZonesOverviewDTOConverter_1.SettingsZonesOverviewDTOConverter).to(SettingsZonesOverviewDTOConverterImpl_1.SettingsZonesOverviewDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return GeneralSettingsAppModule;
}(AppModule_1.AppModule);

exports.GeneralSettingsAppModule = GeneralSettingsAppModule;